import { request } from "./client";

export type AutopilotTrigger = {
  id: string;
  timestamp: string;
  event_type: string;
  workflow_id: string;
  status: "running" | "completed" | "failed";
  nodes_executed?: number | null;
  graph_run_id?: string | null;
  thread_id?: string | null;
  event?: {
    id: string;
    entity_type?: string | null;
    payload?: Record<string, unknown>;
  };
};

export type CrmAutopilotRule = {
  event_type: string;
  workflow_id?: string | null;
  status: "enabled" | "disabled";
  description?: string | null;
};

export async function runAutopilotPass(): Promise<{ dispatched: number }> {
  return request<{ dispatched: number }>("/autopilot/run", { method: "POST" });
}

export async function testAutopilotRule(ruleId: string): Promise<void> {
  await request("/autopilot/test-rule", {
    method: "POST",
    body: { rule_id: ruleId },
  });
}

export function fetchAutopilotTriggers(params?: { type?: string; limit?: number }): Promise<{ items: AutopilotTrigger[] }> {
  const search = new URLSearchParams();
  if (params?.type) search.set("type", params.type);
  if (params?.limit) search.set("limit", String(params.limit));
  const suffix = search.toString();
  return request<{ items: AutopilotTrigger[] }>(`/autopilot/triggers${suffix ? `?${suffix}` : ""}`);
}

export function fetchCrmAutopilotConfig(): Promise<{ rules: CrmAutopilotRule[] }> {
  return request<{ rules: CrmAutopilotRule[] }>("/autopilot/crm-config");
}

export function updateCrmAutopilotRule(rule: CrmAutopilotRule): Promise<CrmAutopilotRule> {
  return request<CrmAutopilotRule>("/autopilot/crm-config/update", {
    method: "POST",
    body: rule,
  });
}

export function fetchMcpAutopilotRules(): Promise<{ rules: McpAutopilotRule[] }> {
  return request<{ rules: McpAutopilotRule[] }>("/autopilot/mcp-rules");
}

export function saveMcpAutopilotRule(rule: McpAutopilotRule): Promise<McpAutopilotRule> {
  return request<McpAutopilotRule>("/autopilot/mcp-rules", {
    method: "POST",
    body: rule,
  });
}

export function deleteMcpAutopilotRule(ruleId: string): Promise<void> {
  return request<void>(`/autopilot/mcp-rules/${encodeURIComponent(ruleId)}`, {
    method: "DELETE",
  });
}
export type McpAutopilotRule = {
  id?: string;
  event_type: string;
  description?: string | null;
  enabled: boolean;
  action: {
    tool: string;
    input_template: Record<string, unknown>;
  };
};
